import React, { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import PageCompLoader from '@/components/loaders/PageCompLoader'
import { addOrganizationADCredentials } from '@/services/setting.service'
import { AZURE_DIRECTORY_FORM, CONNECTOR_TYPES, INVALID_CONSENT_TOKEN } from '@/utils/constants/appConstants/DirectoryConstants'
import { getFromLocalStorage, removeFromLocalStorage } from '@/utils/functions/helperFunctions'
import { successToasterMessage, errorToasterMessage } from '@/utils/functions/toaster'
import { getUserId } from '@/utils/functions/TokenFunction'

const DirectoryServiceSuccess = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false)
    const [queryParams, setQueryParams] = useSearchParams()

    useEffect(() => {
        // Set loading state to true to indicate the start of an async operation
        setLoading(true);
        const token = queryParams.get('token')
        // Call the addOrganizationADCredentials function to add Azure AD credentials
        // Pass the retrieved token ID from local storage and the credential type as 'azure'
        if (token) {
            addOrganizationADCredentials(
                token as string, // Retrieve token ID from local storage, using TypeScript assertion for type safety
                { type: CONNECTOR_TYPES.OIDC }, // Credential type for the operation, specifying it's for Azure AD

                // Success callback function
                (res: any) => {
                    // Set loading state to false as the operation has completed successfully
                    setLoading(false);

                    // Display a success message using a toaster notification
                    successToasterMessage(AZURE_DIRECTORY_FORM.successMsg);

                    // Navigate to the '/settings' page if a user session token exists
                    if (localStorage.getItem('token')) {
                        navigate('/settings');
                    }

                    // Otherwise, navigate to the home page
                    navigate('/');
                },

                // Error callback function
                (err: any) => {
                    // Set loading state to false as the operation has completed with an error
                    setLoading(false);

                    // Display an error message using a toaster notification
                    errorToasterMessage(err);

                    // Navigate to the '/settings' page if a user session token exists
                    if (localStorage.getItem('token')) {
                        navigate('/settings');
                    }

                    // Otherwise, navigate to the home page
                    navigate('/');
                }
            );

        } else {
            errorToasterMessage(INVALID_CONSENT_TOKEN)
            navigate('/')
        }
    }, []);


    return (
        <>
            {loading ? <PageCompLoader /> : ''}
        </>
    )
}

export default DirectoryServiceSuccess